import React from "react";
import { Panel, Table, Tooltip, Whisper } from "rsuite";
import { Link } from "react-router-dom";
import helperInstance from "lib/helper";


const { Column, HeaderCell, Cell } = Table;

export default function AllFeedback({ data, loading }) {

  return (
      <Panel bordered className="bg-white">
          <Table autoHeight={true} data={data} loading={loading}>
            <Column width={75}>
              <HeaderCell>S.No</HeaderCell>
              <Cell>{(rowData, index) => index + 1}</Cell>
            </Column>
            <Column width={300}>
              <HeaderCell>Customer Name</HeaderCell>
              <Cell>
                {(rowData) => (
                  <Link
                    to={`/customer-lead-profile/${rowData?.leadID}`}
                    className="fw-600"
                  >
                    {rowData?.customerName}
                  </Link>
                )}
              </Cell>
            </Column>
            <Column width={150}>
              <HeaderCell>Customer Id </HeaderCell>
              <Cell dataKey="customerID" />
            </Column>
            <Column width={150}>
              <HeaderCell>Lead Id</HeaderCell>
              <Cell dataKey="leadID" />
            </Column>

            <Column width={150}>
              <HeaderCell>Rating</HeaderCell>
              <Cell dataKey="rating" />
            </Column>

            <Column width={300}>
              <HeaderCell>message </HeaderCell>
              <Cell>
                {(rowData) => (
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>{rowData.feedback}</Tooltip>}
                  >
                     {rowData.feedback &&
                      `${rowData.feedback }`
                     }
                  </Whisper>
                )}
              </Cell>
            </Column>

            <Column width={200}>
              <HeaderCell>Created At</HeaderCell>
               <Cell>{(rowData) => helperInstance.formateDate(rowData.created_at)}</Cell>
            </Column>
          </Table>
      </Panel>
  );
}
